import { Context, Effect, Layer, Queue, Stream } from 'effect'
import { registerShortcuts } from '@st/react-util/shortcuts'

export type ShortcutsService = {
  presses: (shortcuts: readonly string[]) => Stream.Stream<string>
}

export class Shortcuts extends Context.Service<Shortcuts, ShortcutsService>()('Shortcuts') {}

export const observeShortcuts = (shortcuts: readonly string[]) =>
  Stream.unwrap(Effect.map(Effect.service(Shortcuts), (service) => service.presses(shortcuts)))

export function shortcutsLayer() {
  return Layer.succeed(Shortcuts, {
    presses: (shortcuts) =>
      Stream.callback<string>((queue) =>
        Effect.acquireRelease(
          Effect.sync(() =>
            registerShortcuts(
              window,
              Object.fromEntries(
                shortcuts.map((shortcut) => [shortcut, () => Queue.offerUnsafe(queue, shortcut)])
              )
            )
          ),
          (unsubscribe) => Effect.sync(unsubscribe)
        )
      )
  })
}

export function shortcutsNoopLayer() {
  return Layer.succeed(Shortcuts, {
    presses: () => Stream.empty
  })
}
